import React, { ChangeEvent } from 'react';
import { Button, LoadingIndicator } from '@company-mrv/mrv-design-system/components';
import './jurosSomadosIpca.css'
import ConfiguracaoSistemaService from '../../../../../lib/api/configuracaoSistema/configuracaoSistemaService';
import ModalComBotaoFechar from '../../../../../lib/components/modalComBotaoFechar/modalComBotaoFechar';
import MensagemModal from '../../../../../lib/components/mensagemModal/mensagemModal';

class JurosSomadosIpca extends React.Component<{}, 
{
    novoValorPreenchido: boolean,
    valorAtual: number | undefined,
    novoValor: any,
    loading: boolean,
    sucessoEnviarParametro: boolean,
    falhaEnviarParametro: boolean,
    buscandoParametro: boolean
}> 
{
    constructor(props: any) 
    {
        super(props);
        this.state = {
            novoValorPreenchido: false,
            valorAtual: undefined,
            novoValor: undefined,
            loading: false,
            sucessoEnviarParametro: false,
            falhaEnviarParametro: false,
            buscandoParametro: true
        };

        this.validarNovoValor = this.validarNovoValor.bind(this);
        this.limparMensagensSucessoErro = this.limparMensagensSucessoErro.bind(this);
        this.possuiMensagemRetorno = this.possuiMensagemRetorno.bind(this);
    }

    componentDidMount() 
    {
        ConfiguracaoSistemaService.obterParametro(1)
            .then((parametro) => 
            {
                this.setState({
                    valorAtual: parametro ? parametro.data.valor * 100 : undefined,
                    buscandoParametro: false
                });
            });
    }

    validarNovoValor(event: ChangeEvent<HTMLInputElement>) 
    {
        const novoValor = event.target.value === '' ? null : +event.target.value;

        if (novoValor !== null && novoValor >= 0) 
        {
            this.setState({
                novoValor,
                novoValorPreenchido: true,
                sucessoEnviarParametro: false,
                falhaEnviarParametro: false
            });
        } else {
            this.setState({
                novoValor: undefined,
                novoValorPreenchido: false,
                sucessoEnviarParametro: false,
                falhaEnviarParametro: false
            });
        }
    }

    submit = async (e: any) => 
    {
        e.preventDefault();
        const novoValor = this.state.novoValor ? this.state.novoValor / 100 : 0;
        this.setState({ loading: true });
        ConfiguracaoSistemaService.enviarParametro({tipo: 1, valor: novoValor})
            .then(() => 
            {
                this.setState({
                    novoValor: '',
                    valorAtual: novoValor * 100,
                    loading: false,
                    novoValorPreenchido: false,
                    sucessoEnviarParametro: true,
                    falhaEnviarParametro: false
                });
            })
            .catch(() => 
            {
                this.setState({
                    loading: false,
                    sucessoEnviarParametro: false,
                    falhaEnviarParametro: true
                });
            });
    }

    limparMensagensSucessoErro(): void 
    {
        this.setState({
            sucessoEnviarParametro: false,
            falhaEnviarParametro: false,
        });
    }

    possuiMensagemRetorno(): boolean 
    {
        return this.state.sucessoEnviarParametro || this.state.falhaEnviarParametro;
    }

    render() 
    {
        return (
            <div className="container-juros-somados">
                <form className="form-input-arquivo" onSubmit={e => this.submit(e)}>
                    <h2 className="titulo-componente">Juros somado ao IPCA</h2>
                    <div className="contaier-informacoes">
                        <label className="label-input">Novo valor
                            <div className="container-input">
                                <input type="number" step=".0001" className="input-novo-valor" value={this.state.novoValor} onChange={this.validarNovoValor} placeholder="ex: 1,0"></input>%
                            </div>

                        </label>

                        <label className="label-input">Valor atual
                            {this.state.buscandoParametro && <LoadingIndicator />}
                            {!this.state.buscandoParametro && <span className="valor-atual">{this.state.valorAtual ? this.state.valorAtual.toFixed(2) + '%' : '-'}</span>}
                        </label>

                    </div>
                    <Button size="small" loading={this.state.loading} className="enviar-arquivo" type="submit" disabled={!this.state.novoValorPreenchido}>Enviar</Button>

                    <ModalComBotaoFechar
                        isOpen={this.possuiMensagemRetorno()}
                        onRequestClose={this.limparMensagensSucessoErro}
                        aoClicarBotaoFecharModal={this.limparMensagensSucessoErro}>
                        {this.state.sucessoEnviarParametro && <MensagemModal mensagem="Parametro atualizado com sucesso"></MensagemModal>}
                        {this.state.falhaEnviarParametro && <MensagemModal mensagem="Erro ao atualizar parametro" erro={true}></MensagemModal>}
                    </ModalComBotaoFechar>
                </form>
            </div>
        );
    }
}

export default JurosSomadosIpca;